import { render, staticRenderFns } from "./UserInfoLabel.vue?vue&type=template&id=7c8883aa&scoped=true&"
import script from "./UserInfoLabel.vue?vue&type=script&lang=js&"
export * from "./UserInfoLabel.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoLabel.vue?vue&type=style&index=0&id=7c8883aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8883aa",
  null
  
)

export default component.exports